import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Candidate} from '../../models/Candidate';
import {Valet} from '../../../../admin/modules/admin-valet/models/valet';
import {ValetDocument, ValetDocuments} from '../../../../common-modules/common-valet/models/valet-document';
import {PvRecruitmentService} from '../../pv-recruitment.service';
import {AuthService} from '../../../../shared/services/auth.service';
import {USER_ROLE} from 'src/app/shared/models/user';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {GeneralTermsService} from '../../../../common-modules/common-general-terms/services/general-terms.service';
import {GeneralTerms} from '../../../../common-modules/common-general-terms/models/GeneralTerms';

@Component({
    selector: 'pv-recruitment-general-terms-step',
    templateUrl: './recruitment-general-terms-step.component.html',
    styleUrls: ['./recruitment-general-terms-step.component.scss'],
    standalone: false
})
export class RecruitmentGeneralTermsStepComponent implements OnInit, OnDestroy {

  public USER_ROLE = USER_ROLE;
  public documents: ValetDocuments;
  public lastTerms: GeneralTerms;
  public acceptingGeneralTerms = false;
  private destroy$: Subject<void> = new Subject<void>();

  @Input() candidate: Candidate;
  @Input() valet: Valet;
  @Input() reloadDocument$: Subject<void>;

  @Output() reloadUser = new EventEmitter();

  constructor(private recruitmentService: PvRecruitmentService,
              private authService: AuthService,
              private generalTermsService: GeneralTermsService) { }

  ngOnInit(): void {
    this.getCandidateDocuments();
    this.reloadDocument$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.getCandidateDocuments();
    });

    this.generalTermsService.getUserLastTerms().then(lastTerms => {
      this.lastTerms = lastTerms;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  private getCandidateDocuments(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.recruitmentService.getCandidateDocuments().then(res => {
        this.documents = res;
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  }

  updateDocument(document: ValetDocument) {
    this.recruitmentService.updateCandidateDocument(document).then(res => {
      document.isSubmitting = false;
      this.documents = res;
      this.authService.getUserData().toPromise().then((user: any) => {
        this.candidate = user.data.candidate;
      });
    }).catch(err => {
      document.isSubmitting = false;
    });
  }

  acceptGeneralTerms() {
    this.acceptingGeneralTerms = true;
    this.generalTermsService.approvedGeneralTerms(this.lastTerms.id).then(() => {
      this.reloadUser.emit();
    }).finally(() => {
      this.acceptingGeneralTerms = false;
    });
  }
}
